(ns humbleai.belt.malli.core
  (:refer-clojure :exclude [type select-keys merge])
  (:require
   [malli.core :as malli]
   [malli.error :as error]
   [malli.util :as util]))

;; TODO specter navigators

(defn entity-type
  [?sub-schema]
  (-> ?sub-schema malli/properties :type))

(defn invalid-input-exception?
  [exception]
  (some-> exception
          (ex-data)
          (:message)
          (= :malli.core/invalid-input)))

(defn humanise
  [explain-data]
  (error/humanize explain-data {:wrap #(clojure.core/select-keys % [:value :message])}))

(defn humanise-exception
  [exception]
  (some-> exception
          (ex-data)
          (:data)
          (:explain)
          (humanise)))

(defn active-schema
  [schema value]
  (assert schema)
  (malli/walk
   schema
   (malli/schema-walker
    (fn [schema]
      (cond-> schema
        (malli/entries schema)
        (util/transform-entries
         (partial filter (fn [[_ {::keys [active?]} _]]
                           (cond
                             (nil? active?) true
                             (ifn? active?) (active? value)
                             :else active?)))))))))

;; Exporting Malli symbols for convenience and because we will likely soon be wrapping/modifying
;; them.
(def type malli/type)
(def walk malli/walk)
(def schema-walker malli/schema-walker)
(def children malli/children)
(def default-schemas malli/default-schemas)
(def form malli/form)
(defn schema
  ([?schema]
   (schema ?schema nil))
  ([?schema options]
   (try
     (malli/schema ?schema options)
     (catch #?(:cljs js/Error :clj Exception) _))))
(def coerce malli/coerce)
(def coercer malli/coercer)
(def decode malli/decode)
(def decoder malli/decoder)
(def encode malli/encode)
(def encoder malli/encoder)
(def explain malli/explain)
(def properties malli/properties)
(def validate malli/validate)
(def parser malli/parser)

(def subschemas util/subschemas)
(def select-keys util/select-keys)
(def update-properties util/update-properties)
(def transform-entries util/transform-entries)

(defn merge
  ([] nil)
  ([schema] schema)
  ([left right] (util/merge left right))
  ([left right & rest] (reduce util/merge left (cons right rest))))
